import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Nav from './components/Nav';
import Head from './components/Head';
import Home from './pages/Home';
import Pizzas from './pages/Pizzas';
import Bocadillos from './pages/Bocadillos';
import Novedades from './pages/Novedades';
import Paninis from './pages/Paninis';
import MenusKebab from './pages/MenusKebab';
import Tarrinas from './pages/Tarrinas';
import Encargos from './pages/Encargos';
import Hamburguesas from './pages/Hamburguesas';
import Tacos from './pages/Tacos';
import Bebidas from './pages/Bebidas';
import PlatosCombinados from './pages/PlatosCombinados';
import Footer from './components/Footer';
import ModalNovedadShusi from './components/ModalNovedadShusi';

function App() {
  return (
    <Router>
      <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet"></link>
      <Head title="CasaBlanca" subtitle="Kebab!" />
      <section class="container mx-auto mt-8 px-6">
        <div class="relative">
          <img src="https://i.ibb.co/RkpKNpwn/Imagen-de-Whats-App-2025-09-16-a-las-20-44-12-d3a891a5.jpg"
            class="w-full rounded-2xl shadow-lg object-cover h-96" />
          {/*   <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
            <h1 class="text-4xl font-bold text-white mb-4 shadow-md">El mejor Kebab de la Mancha Real</h1>
            <a href="#menu" class="btn-primary">Ver Menú</a>
          </div> */}
        </div>
      </section>
      <div className="App container my-5">
        <Nav />
        <a href="tel:632367041" class="phone-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="35" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
          </svg>
        </a>
        <main id="menu">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/novedades" element={<Novedades />} />
            <Route path="/menusKebab" element={<MenusKebab />} />
            <Route path="/menusPatatas" element={<Tarrinas />} />
            <Route path="/paninis" element={<Paninis />} />
            <Route path="/pizzas" element={<Pizzas />} />
            <Route path="/tacos" element={<Tacos />} />
            <Route path="/platosCombinados" element={<PlatosCombinados />} />
            <Route path="/hamburguesas" element={<Hamburguesas />} />
            {/*             <Route path="/bebidas" element={<Bebidas />} /> */}
            <Route path="/encargos" element={<Encargos />} />
          </Routes>
        </main>
        <ModalNovedadShusi />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
